const faqs = [
  {
    id: 1,
    heading: "What types of pastries do you offer?",
    content: "At Sweet Delight, we offer a delightful range of pastries including classic croissants, Danish pastries, éclairs, and more. Explore our selection to find your perfect treat.",
  },
  {
    id: 2,
    heading: "What sets your bakery apart from others?",
    content: "Sweet Delight stands out for our quality ingredients, artisanal craftsmanship, and passion for baking. We prioritize customer satisfaction to create memorable bakery experiences.",
  },
  {
    id: 3,
    heading: "Do you offer custom cake designs?",
    content: "Yes, we specialize in creating custom cakes for your celebrations. Contact us and we’ll work closely with you to design the perfect cake with flavors, decorations, and themes.",
  },
  {
    id: 4,
    heading: "Can I place an online order for your bakery treats?",
    content: "Absolutely! Browse our online menu, add your favorite treats to the cart, and place your order. Your freshly baked goodies will be ready for pickup or convenient delivery.",
  },
  {
    id: 5,
    heading: "Are there gluten-free options available?",
    content: "Certainly! We offer a selection of gluten-free treats including cakes, cookies, and bread. Enjoy delicious creations that cater to your dietary preferences and restrictions.",
  },
];

export default faqs;